<template>
  <div>
  </div>
</template>

<script>
var THREE = {
  ...require('three'),
  ...require('three/examples/jsm/loaders/OBJLoader.js'),
  ...require('three/examples/jsm/loaders/FBXLoader.js')
}
export default {
  props: {
    scene: {},
    engine: {}
  },
  data () {
    return {
      mounter: new THREE.Object3D()
    }
  },
  methods: {
    loadFBX () {
      this.loader = new THREE.FBXLoader()
      // eslint-disable-next-line
      let file = require('file-loader!./model/rocket-colored-v2.fbx')
      this.loader.load(file, (obj) => {
        window.obj = obj
        window.THREE = THREE

        var light = new THREE.PointLight(0xffffff, 8, 1000)
        light.position.set(50, 500, 50)
        this.mounter.add(light)

        var atmosphwere = new THREE.AmbientLight(0xffffff)
        this.mounter.add(atmosphwere)

        obj.children[0].scale.multiplyScalar(100)
        obj.children[0].position.x = -250
        obj.children[0].position.z = -50
        this.mounter.add(obj)

        // this.setup({ obj: obj.children[0] })
      })
    }
  },
  mounted () {
    this.loadFBX()
    this.scene.add(this.mounter)
  },
  beforeDestroy () {
    this.scene.remove(this.mounter)
  }
}
</script>

<style>

</style>
